import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/sim-resource", params);
};

const getLookup = () => {
  return restApi.get("/api/sim-resource/lookup");
};

const upsert = data => {
  return restApi.post("/api/sim-resource/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/sim-resource/${ids}`);
};

const getAllForCSV = (params) => {
  return restApi.post("/api/sim-resource/csv", params);
}

const simResourceService = {
  getAll,
  getLookup,
  upsert,
  remove,
  getAllForCSV
};

export default simResourceService;